import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { apiRequest } from '../hooks/useApi.js'
import { useAnnouncer } from '../contexts/AnnouncerContext.jsx'

const DIFFICULTY_LABELS = {
  iniciante: 'Iniciante',
  intermediario: 'Intermediário',
  expert: 'Expert',
}

export default function MenuScreen() {
  const navigate = useNavigate()
  const { announce, alertSR } = useAnnouncer()
  const [showDifficulty, setShowDifficulty] = useState(false)
  const [loadingContinue, setLoadingContinue] = useState(false)

  async function handleContinue() {
    setLoadingContinue(true)
    try {
      await apiRequest('GET', '/game/state')
      navigate('/game')
    } catch (err) {
      if (err.message.includes('404') || err.message.includes('No active game')) {
        alertSR('Nenhuma partida em andamento para continuar.')
      } else {
        alertSR(`Erro ao carregar partida: ${err.message}`)
      }
    } finally {
      setLoadingContinue(false)
    }
  }

  async function startNewGame(difficulty) {
    setShowDifficulty(false)
    try {
      const data = await apiRequest('POST', '/game/new', { difficulty, tutorial_mode: false })
      if (data) {
        announce(`Nova partida iniciada com dificuldade ${DIFFICULTY_LABELS[difficulty] || difficulty}.`)
        navigate('/game')
      }
    } catch (err) {
      alertSR(`Erro ao criar partida: ${err.message}`)
    }
  }

  return (
    <section aria-labelledby="menu-heading">
      <h2 id="menu-heading">Menu Principal</h2>
      <div className="menu-actions">
        <button
          type="button"
          className="btn btn-primary btn-large"
          onClick={() => {
            setShowDifficulty(true)
            announce('Escolha a dificuldade.')
          }}
        >
          Nova Partida
        </button>

        <button
          type="button"
          className="btn btn-secondary btn-large"
          onClick={handleContinue}
          disabled={loadingContinue}
        >
          {loadingContinue ? 'Carregando...' : 'Continuar Partida'}
        </button>

        <button
          type="button"
          className="btn btn-secondary btn-large"
          onClick={() => navigate('/stats')}
        >
          Estatísticas
        </button>

        <button
          type="button"
          className="btn btn-secondary btn-large"
          onClick={() => navigate('/settings')}
        >
          Configurações
        </button>
      </div>

      {showDifficulty && (
        <div id="difficulty-selection">
          <h3>Escolha a dificuldade</h3>
          <div className="difficulty-options">
            {['iniciante', 'intermediario', 'expert'].map((d) => (
              <button
                key={d}
                type="button"
                className="btn btn-secondary btn-large"
                onClick={() => startNewGame(d)}
              >
                {DIFFICULTY_LABELS[d] || d}
              </button>
            ))}
          </div>
          <button
            type="button"
            className="btn btn-link"
            onClick={() => setShowDifficulty(false)}
          >
            Cancelar
          </button>
        </div>
      )}
    </section>
  )
}
